export class NotFoundException implements Error {
    public name = 'Not found Exception'
    public message = 'HTTP Request failed with 404 not found!'
}
